// extracted by mini-css-extract-plugin
module.exports = {"prev":"PostContent-module--prev--QBbmc","next":"PostContent-module--next--2NHO6","container":"PostContent-module--container--12A9U","caption":"PostContent-module--caption---HzJk"};